import {Injectable} from '@angular/core';

// Classes
import {Product} from '../classes/product';

let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:ProductsPackagesService'));

@Injectable()
export class ProductsPackagesService {

    private _productsService = null;

    
    constructor () {
        // 'Construct products packages service' );
    }

    
    public init (productsService) {
        // 'Initialise products packages service' );
        this._productsService = productsService;
    }

    /** Creates `product.package.products` from `product.package.config`
     */
    public generatePackageProducts (product: Product) {
        // '"' + product.code + '" - Generate package products' );

        let self = this;

        if (product.package.config === undefined ||
            product.package.config === null
        ) {
            console.warn( ' "' + product.code + '" product has no package products defined' );
            return;
        }

        // Add base products (base products are permanent)
        debugOff( '"' + product.code + '" - Clone package base products' );
        if (product.package.config.staticProducts !== undefined &&
            product.package.config.staticProducts.length !== 0) {

            // Get static products ids
            let staticProducts = product.package.config.staticProducts;
            if (staticProducts === undefined) { console.warn( '"' + product.code + '.staticProducts" is undefined' ); return; }
            let packProdsIdsList = staticProducts.map( obj => obj['productId'] );

            for ( let propertyId in product.package.config.dynamicProducts ) {

                // Get dynamic products ids
                let dynamicProducts = product.package.config.dynamicProducts[propertyId];
                if (dynamicProducts === undefined) {
                    console.warn( '"' + product.code + '.package.config.dynamicProducts.' + propertyId + '" is undefined' ); return;
                }
                let dynamicPackProdsIdsList = dynamicProducts.map( obj => obj['productId'] );

                // Add to products ids list
                packProdsIdsList = packProdsIdsList.concat( dynamicPackProdsIdsList );
            }

            debugOff( '"' + product.code + '" - Package products ids:', packProdsIdsList );

            let packageProducts: Array<Product> = [];

            // Get clones of the required products.
            // This prevents cross-talk between product packages that use the same child products
            packProdsIdsList.forEach( packProdId => {
                let requiredProduct: Product = self._productsService.getProductById( packProdId );
                let clone = requiredProduct.getClone();
                packageProducts.push( clone );
            });
            
            // Sync package children products with package parent product
            packageProducts.forEach( (packProduct: Product) => {

                // Sync options between parentProduct and childProduct
                // TODO: Fix property sync issue
                // packProduct.syncWithProduct( product, ['optionsSelected', 'categoryId'] );

                // If package child product has options, clone them from package parent product
                if (packProduct.options) {
                    packProduct.options.selected = product.options.selected;
                }
                // packProduct.taxonomy.categories = product.taxonomy.categories; // Uneeded, created separete propery for image folder

                                // // '--- "' + packProduct.id + '.categoryId" - Synced value:', packProduct.categoryId );
                                // // '--- "' + packProduct.id + '.optionsSelected" - Synced value:', packProduct.optionsSelected );
                                // // '--- "' + packProduct.id + '.imageScene":', packProduct.imageScene );

                // Updates dynamic properties. Usually child products are not product packages.
                // packProduct.updateDynamicProperties();
                self._productsService._dynamicPropertiesService.updateDynamicProperties( packProduct );

                                // // '--- "' + packProduct.id + '.categoryId" - Synced value:', packProduct.categoryId );
                                // // '--- "' + packProduct.id + '.optionsSelected" - Synced value:', packProduct.optionsSelected );
                                // // '--- "' + packProduct.id + '.imageScene":', packProduct.imageScene );
            });

            // Create package products array
            product.package.products = [];

            // Cache the package products
            product.package.products = product.package.products.concat( packageProducts );
        }

        // '"' + product.code + '" - Package products:', product.package.products );
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/catalog/shared/services/products-packages-service.ts